import { render, staticRenderFns } from "./DetailClassBootcamp.vue?vue&type=template&id=699ed000"
import script from "./DetailClassBootcamp.vue?vue&type=script&lang=js"
export * from "./DetailClassBootcamp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports